// extracted by mini-css-extract-plugin
module.exports =  {"root":"oai3UdkHA_H3XoTX3rIG","icon":"eVBXaSFUvG1usch8GxSD"};